export const iconFontAwesomeHumanitarianRoadSpikes = (
	<i className="fa-solid fa-road-spikes"></i>
);
